import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  openAddFromTemplate({ component: pageComponent });
}

export function openAddFromTemplate({ component } = {}) {
  component.setState({ jobPlanningCodeAddFromTemplateShow: true });
  setTimeout(() => {
    component.jobPlanningCodeAddFromTemplate.current?.setState({ defaultSelectedRowKeys: [], selectedRowKeys: [] });
    setTimeout(() => {
      component.jobPlanningCodeAddFromTemplate.current?.getPlanningCodeOption();
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}
